import { useContext } from "react";

import { StateContext } from "../context/globalContext/context";
import { iGlobalContext } from "../context/globalContext/interface";
import { useResetState } from "../utils/resetBookingData";

export const useSignOutReset = () => {
  const {
    setScreen,
    setFirstScreen,
    setUserInfo,
    setIsLoggedIn,
    setNav,
    setSelectedDestFlag,
    setStartingValue,
    setDestValue,
    setClimate,
    setPopulation,
    setExperience,
    setFoodPreferences,
    setAccomodations,
    setMonths,
    setBudget,
    setTripForNDays,
  }: iGlobalContext = useContext(StateContext);
  const resetState = useResetState();

  function resetStateValues(setters: React.Dispatch<React.SetStateAction<any[]>>[]) {
    setters.forEach((setter) => setter([]));
  }

  function resetAppState() {
    setScreen("");
    setFirstScreen("");
    resetState();
    window.localStorage.removeItem("_zenvoya_JWT");

    const resetUserInfo = {
      id: "",
      name: "",
      email: "",
      phone: "",
      profile_pic: "",
      loggedIn: false,
      role: 0,
    };
    [setUserInfo].forEach((setFunc) => setFunc(resetUserInfo));
    setIsLoggedIn(false);

    setNav("LANDING_PAGE");
    setSelectedDestFlag(false);
    setStartingValue({ value: "", flag: false });
    setDestValue({ value: "", flag: false });

    resetStateValues([
      setClimate,
      setPopulation,
      setExperience,
      setFoodPreferences,
      setAccomodations,
      setMonths,
      setBudget,
      setTripForNDays,
    ]);
  }

  function postLogoutMessage() {
    const iframe = document.querySelector("#app_domain") as HTMLIFrameElement | null;
    const wind = iframe?.contentWindow;
    wind?.postMessage(JSON.stringify({}), "*");

    if (window && window.parent) {
      const message = {
        action: "logout",
        data: {},
      };
      window.parent.postMessage(JSON.stringify(message));
    }
  }

  return { resetAppState, postLogoutMessage };
};
